<script>
import useSharedData from "@/use/SharedData.js";
import useTools from "@/use/Tools.js";
import {onMounted, ref} from "vue";
import useSharedMethod from "@/use/SharedMethod";
import {useOccupationStore} from "@/stores/Occupation";
import useValidation from "@/use/Validation";
import axios from "axios";

export default {
    setup() {
        const {mxRules} = useValidation();
        const {dialog, loading} = useSharedData();
        const {$route, $refs} = useTools();
        const {getBack} = useSharedMethod();
        const occupation = ref({});
        const fromId = ref(null);
        const occupationStore = useOccupationStore();

        function findById(id) {
            loading.value = true;
            axios.get(`/occupations/${id}`).then(response => {
                occupation.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        function importer() {
            if ($refs.form.validate()) {
                loading.value = true;
                axios.put(`/occupations/importPaySections/${fromId.value}/${$route.params.id}`).then(response => {
                    occupationStore.updateOccupation(response.data);
                    getBack();
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        onMounted(() => findById($route.params.id));

        return {
            mxRules,
            dialog,
            loading,
            occupation,
            fromId,
            importer,
            getBack,
        }
    }
}
</script>

<template>
    <v-dialog
            v-model="dialog"
            persistent
            max-width="500"
            scrollable
    >
        <v-card>
            <w-toolbar color="teal" :title="`${$t('occupation.import_pay_sections')} : ${occupation.name}`"/>
            <v-card-text>
                <v-container fluid>
                    <v-form ref="form" lazy-validation>
                        <v-row dense>
                            <v-col cols="12">
                                <w-label :label="$t('module.occupation')" required/>
                                <str-occupation-autocomplete
                                    v-model="fromId"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <w-btn-close @press="getBack"/>
                <w-btn-import
                    :loading="loading"
                    @press="importer"
                />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>